import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
/* eslint-disable */
'use strict'; // platform throws error without this

const mobileTypeObjectKey = 'mobile';
const androidTypeObjectKey = 'android';
const defaultTypeObjectKey = 'default';

/**
 * @method checkForRequiredAttributes
 * @description makes sure the element's attributes contain all required attributes
 * @param {Object} attributes object of attributes to be applied to element
 * @param {Array} required array of attributes that must be present
 * @returns Boolean
 */
function checkForRequiredAttributes(attributes, required) {
  return required.every((key) => {
    return attributes.hasOwnProperty(key);
  });
}

function parseViewportDependentAttribute(attribute) {
  let defaultAttr = '';
  let mobileAttr = '';
  let androidAttr = '';

  if (typeof attribute === 'string') {
    defaultAttr = attribute;
    mobileAttr = attribute;
    androidAttr = attribute;
  } else {
    if (typeof attribute[mobileTypeObjectKey] !== 'undefined') {
      mobileAttr = attribute[mobileTypeObjectKey];
    }

    if (typeof attribute[androidTypeObjectKey] !== 'undefined') {
      androidAttr = attribute[androidTypeObjectKey];
    }

    if (typeof attribute[defaultTypeObjectKey] !== 'undefined') {
      defaultAttr = attribute[defaultTypeObjectKey];
    }
  }

  return {
    defaultAttr,
    mobileAttr,
    androidAttr,
  };
}

/**
 * @method formatTextInput
 * @description builds Handlebars string for input markup based on parameters
 * @param {Object} inputData object containing parameters for this input
 * @param {String} defaultInputAttributes input attributes to use by default
 * @returns Handlebars.SafeString
 */
function formatTextInput(data, defaultInputAttributes) {
  const requiredAttrs = ['id'];

  const combinableAttrs = ['class', 'value'];

  const defaultAttrs = JSON.parse(JSON.stringify(defaultInputAttributes));
  const inputData = JSON.parse(JSON.stringify(data));

  const applyGISMask = inputData.input['gis-mask'];

  const applyDatepicker = inputData.input.datepicker;

  if (typeof applyGISMask !== 'undefined') {
    defaultAttrs.input.attrs.class += ' gis-mask';
    inputData.input.attrs['data-field-type'] = applyGISMask;
  }

  if (typeof applyDatepicker !== 'undefined' && applyDatepicker) {
    defaultAttrs.input.attrs.class += ' datepicker';
  }

  combinableAttrs.forEach((attr) => {
    if (typeof defaultAttrs.input.attrs[attr] !== 'undefined' && typeof inputData.input.attrs[attr] !== 'undefined') {
      if (typeof inputData.input.attrs[attr] !== 'undefined' && attr === 'value') {
        defaultAttrs.input.attrs[attr] = `${inputData.input.attrs[attr]}${defaultAttrs.input.attrs[attr]}`;
      } else if (inputData.input.attrs[attr]) {
        defaultAttrs.input.attrs[attr] = `${inputData.input.attrs[attr]} ${defaultAttrs.input.attrs[attr]}`;
      }
    }
  });

  const maskOptions = Object.assign({}, inputData.input.attrs['data-sparta-input-mask']);

  const maskDefaults = Object.assign({}, defaultAttrs.input.attrs['data-sparta-input-mask']);

  const mask = Object.assign({}, maskDefaults, maskOptions);

  const inputAttributes = Object.assign({}, inputData.input.attrs, defaultAttrs.input.attrs, { 'data-sparta-input-mask': mask });

  const reservedAttrs = ['type', 'pattern', 'data-help-link', 'data-help-head', 'data-help-body'];

  const format = inputData.input.format;

  const validationRules = inputData.validationRules;

  const attrsStr = [];

  const helpToggle = inputData.helpToggle ? inputData.helpToggle : inputData.label.text;

  if (!checkForRequiredAttributes(inputData.input.attrs, requiredAttrs)) {
    throw new Error(`You are missing one of the following required attributes:  ${requiredAttrs.join(', ')}`);
  }

  const defaultFormatAttributes = {};

  if (format) {
    defaultFormatAttributes['data-sparta-input-format'] = format;
  }

  const formatAttributes = {
    name: {
      autocorrect: 'off',
      autocomplete: 'name',
    },
    phone: {
      autocomplete: 'tel',
      autocorrect: 'off',
      'data-sparta-input-mask': {
        alias: 'phone',
        mask: '999-999-9999',
        jitMasking: false,
        greedy: true,
        placeholder: '_',
      },
    },
    'phone-extended': {
      autocomplete: 'tel',
      autocorrect: 'off',
      'data-sparta-input-mask': {
        alias: 'phone',
        mask: '999-999-9999[ x9{1,4}]',
        jitMasking: false,
        greedy: true,
        placeholder: '_',
      },
    },
    email: {
      autocorrect: 'off',
      autocapitalize: 'off',
      autocomplete: 'email',
    },
    'street-address': {
      autocomplete: 'street-address',
    },
    address: {
      autocomplete: 'address-line1',
    },
    'address-2': {
      autocomplete: 'address-line2',
    },
    city: {
      autocomplete: 'address-level2',
    },
    state: {
      autocomplete: 'address-level1',
    },
    zip: {
      autocomplete: 'postal-code',
      pattern: '[0-9]*',
      inputmode: 'numeric',
      novalidate: true,
      autocorrect: 'off',
      'data-sparta-input-mask': {
        mask: '99999',
      },
    },
    'zip-extended': {
      type: "text",
      autocomplete: 'postal-code',
      pattern: '[0-9]*',
      inputmode: 'numeric',
      novalidate: true,
      autocorrect: 'off',
      'data-sparta-input-mask': {
        mask: '99999[-9999]',
      },
    },
    'cc-number': {
      autocomplete: 'cc-number',
      inputmode: 'numeric',
      pattern: '[0-9]*',
      novalidate: true,
      autocorrect: 'off',
      'data-sparta-input-mask': {
        mask: '9999 9999 9999 9999',
      },
    },
    'cc-csc': {
      autocomplete: 'cc-csc',
      inputmode: 'numeric',
      pattern: '[0-9]*',
      novalidate: true,
      autocorrect: 'off',
      'data-sparta-input-mask': {
        mask: '9{3,4}',
      },
    },
    ssn: {
      pattern: '[0-9]*',
      novalidate: true,
      'data-sparta-input-mask': {
        mask: '999-99-9999',
        jitMasking: false,
        greedy: true,
        placeholder: '_',
      },
    },
    vin: {
      'data-sparta-input-mask': {
        alias: 'vin',
      },
    },
    'external-account': {
      pattern: '[0-9]*',
      novalidate: true,
      'data-sparta-input-mask': {
        alias: 'numeric',
        groupSeparator: '',
        autoGroup: false,
        digits: 0,
        rightAlign: false,
      },
    },
    'internal-account': {
      pattern: '[0-9]*',
      novalidate: true,
      'data-sparta-input-mask': {
        alias: 'numeric',
        groupSeparator: '',
        autoGroup: false,
        digits: 0,
        rightAlign: false,
      },
    },
    date: {
      inputmode: 'numeric',
      novalidate: true,
      autocorrect: 'off',
      pattern: '[0-9]*',
      'data-sparta-input-mask': {
        alias: 'mm/dd/yyyy',
        jitMasking: true,
        greedy: false,
        placeholder: '',
      },
    },
    number: {
      novalidate: true,
      'data-sparta-input-mask': {
        alias: 'numeric',
        groupSeparator: ',',
        autoGroup: true,
        digitsOptional: true,
        decimalProtect: true,
        rightAlign: false,
        digits: 0,
        placeholder: '',
      },
    },
    currency: {
      novalidate: true,
      'data-sparta-input-mask': {
        alias: 'currency',
        prefix: '',
        allowMinus: true,
        rightAlign: false,
        digitsOptional: true,
        digits: 2,
      },
    },
    percentage: {
      novalidate: true,
      'data-sparta-input-mask': {
        showMaskOnFocus: true,
        alias: 'percentage',
        allowMinus: true,
        digitsOptional: true,
      },
    },
    'interest-rate': {
      novalidate: true,
      'data-sparta-input-mask': {
        showMaskOnFocus: true,
        alias: 'percentage',
        digits: 2,
        digitsOptional: true,
        rightAlign: false,
      },
    },
  };

  const inputMaskDefaults = {
    greedy: true,
    placeholder: '',
    clearMaskOnLostFocus: true,
    showMaskOnHover: false,
    showMaskOnFocus: true,
    keepStatic: true,
    jitMasking: true,
    showTooltip: false,
    inputEventOnly: true,
  };

  const maskAttributes = Object.assign({}, defaultFormatAttributes['data-sparta-input-mask'], ((formatAttributes[format]) ? formatAttributes[format]['data-sparta-input-mask'] : {}), mask);

  const attributes = Object.assign({}, defaultFormatAttributes, ((formatAttributes[format]) ? formatAttributes[format] : {}), inputAttributes, { 'data-sparta-input-mask': maskAttributes });

  let defaultInputType = '';
  let mobileInputType = '';
  let androidInputType = '';
  let defaultPattern = '';
  let mobilePattern = '';

  reservedAttrs.forEach((key) => {
    if (attributes[key]) {
      let attrs;

      switch (key) {
        case 'type':
          attrs = parseViewportDependentAttribute(attributes[key]);

          defaultInputType = attrs.defaultAttr;
          mobileInputType = attrs.mobileAttr;
          androidInputType = attrs.androidAttr;

          break;
        case 'pattern':
          attrs = parseViewportDependentAttribute(attributes[key]);

          defaultPattern = attrs.defaultAttr;
          mobilePattern = attrs.mobileAttr;

          break;
        default:
          break;
      }

      attributes[key] = undefined;
    }
  });

  Object.keys(attributes).forEach((key) => {
    if (typeof attributes[key] !== 'undefined') {
      if (typeof attributes[key] !== 'string' && !(attributes[key] instanceof RegExp)) {
        attrsStr.push(`${key}='${((key === 'data-sparta-input-mask') ? JSON.stringify(Object.assign({}, inputMaskDefaults, attributes[key])) : JSON.stringify(attributes[key]))}'`);
      } else if (attributes[key] !== '') {
        attrsStr.push(`${key}="${attributes[key]}"`);
      }
    }
  });

  let inputHelpTrigger = '';
  let inputHelpContainerOpen = '';
  let inputHelpContainerClose = '';
  let inputHelpClose = '';
  let inputHelpBody = '';

  const inputContainerOpen = `<div class="
    spa-input spa-input-box spa-input--${(inputData.skin) ? inputData.skin : 'sparta2'}
    ${(inputData.containerClasses) ? ` ${inputData.containerClasses.join(' ')}` : ''}
    ${(inputData.input.attrs['data-help-body']) ? ' has-help' : ''}
  ">`;

  const inputContainerClose = '</div>';

  const inputLabelRequiredSpan = (required, asterisk) => {
    if (required && asterisk === false) {
      return "<span class='spa-input-label--required'></span>";
    } else if (required) {
      return "<span class='spa-input-label--required'> *</span>";
    }
    return "";
  };

  const inputLabel = `<label class="spa-input-label" data-font="cnx-medium" id="labelFor${inputData.input.attrs.id}" for="${inputData.input.attrs.id}">
    ${inputData.label.text}
    ${inputLabelRequiredSpan(inputData.required, inputData.asterisk)}
    <span class='ada-hidden'>
      ${(inputData.label.adaText) ? inputData.label.adaText : ''}
    </span>
  </label>`;

  let ariaDescribedBy = 'aria-describedby="';
  let isDescribedByAriaTag = false;

  if (inputData.input.attrs['data-help-body']) {
    ariaDescribedBy += `helpLayer_${inputData.input.attrs.id}`;
    isDescribedByAriaTag = true;
  }
  if (inputData.hintText) {
    if (isDescribedByAriaTag) {
      ariaDescribedBy += ` helpFor_${inputData.input.attrs.id}`
    } else {
      ariaDescribedBy += `helpFor_${inputData.input.attrs.id}`
    }
    isDescribedByAriaTag = true;
  }
  ariaDescribedBy += '"';

  let inputField = `<input type="${(defaultInputType || 'text')}"` +
    `aria-labelledby="labelFor${inputData.input.attrs.id}"` +
    `${(defaultPattern) ? `pattern="${defaultPattern}"` : ''}` +
    `${(mobileInputType) ? ` data-mobile-input-type="${mobileInputType}" data-default-input-type="${defaultInputType}"` : ''}` +
    `${(androidInputType) ? ` data-android-input-type="${androidInputType}"` : ''}` +
    `${(typeof mobilePattern !== 'undefined') ? ` data-mobile-pattern="${mobilePattern}" data-default-pattern="${defaultPattern}"` : ''}` +
    `${attrsStr.join(' ')}` +
    `${(validationRules) ? ` data-validation-rules='${JSON.stringify(validationRules).replace(/'/g, '&#39;')}'` : ''}` +
    `${(inputData.required) ? ` required aria-required="true" ${(typeof inputData.required === 'string') ? `data-required-error-message="${inputData.required}"` : ''}` : ''}` +
    `${(inputData.disabled) ? ' disabled aria-disabled="true"' : ''}` +
    `${(isDescribedByAriaTag) ? ariaDescribedBy : ''}` +
  '/>';

  if (inputData.currency) {
    inputField = `<span class="spa-input-prefix--currency">${inputData.currency}</span>${inputField}`;
  }

  const inputHint = `<p class="spa-input-hint" id="helpFor_${inputData.input.attrs.id}">${(inputData.hintText) ? inputData.hintText : ''}</p>`;

  const inputError = `<div class="spa-input-error-message spa-icon--error" id="${inputData.input.attrs.id}_errorMessage" aria-hidden="true"></div>`;

  if (inputData.input.attrs['data-help-body']) {
    // Add a help pop-up trigger, either a question mark or some link text.
    const triggerText = inputData.input.attrs['data-help-link'] || '';
    const triggerClass = triggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button';
    inputHelpTrigger = `<a href="javascript: void(0);" id="help-open-${inputData.input.attrs.id}" role="button" aria-label="${helpToggle}" class="${triggerClass}">${triggerText || '&#160;'}</a>`;
    if (!triggerText) {
      inputHelpTrigger = `<span class="toggle-trigger-box">${inputHelpTrigger}</span>`;
    }

    if (inputData.input.helpTriggerLink) {
        inputHelpTrigger = inputData.input.helpTriggerLink;
    }

    inputHelpContainerOpen = `<div class="input-help" id="helpLayer_${inputData.input.attrs.id}" role="tooltip" aria-hidden="true">`;

    inputHelpContainerClose = '</div>';

    inputHelpClose = `<a href="javascript:void(0)" id="help-close-${inputData.input.attrs.id}" role="button" aria-label="${helpToggle}" class="close-trigger svg-button">&#160;</a>`;

    inputHelpBody = `<div class="body">${inputData.input.attrs['data-help-body']}</div>`;

    if (inputData.input.attrs['data-help-head']) {
      inputHelpBody = '<div class="head" data-font="cnx-bold">' +
        `${inputData.input.attrs['data-help-head']}` +
      '</div>' +
      `${inputHelpBody}`;
    }
  }

  // concatenating because line breaks can mess up the rendering of the html
  const inputElement = `${inputContainerOpen}` +
    `${inputLabel}` +
    `${inputField}` +
    `${inputHelpTrigger}` +
    `${inputHint}` +
    `${inputHelpContainerOpen}` +
      `${inputHelpClose}` +
      `${inputHelpBody}` +
    `${inputHelpContainerClose}` +
    `${inputError}` +
  `${inputContainerClose}`;
  return new Handlebars.SafeString(inputElement);
}

const defaultInputType = 'text';

const defaultAttributes = {
  type: defaultInputType,
  class: 'spa-input-text',
  value: '',
  'data-gis-mask': false,
  'data-help-link': '',
  'data-help-head': '',
  'data-help-body': '',
};

class InputConfig {
  constructor(options) {
    const attrs = Object.assign({}, defaultAttributes, options);

    this.input = {
      attrs,
    };
  }
}

const textInputConfig = new InputConfig();

const dateInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'date',
  },
  inputMode: 'date',
});

const monthYearDateConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'month',
  },
});

const ssnInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel',
  },
  inputMode: 'numeric',
  pattern: '[0-9]*',
});

const emailInputConfig = new InputConfig({
  type: 'email',
});

const phoneInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel',
  },
  inputMode: 'numeric',
  pattern: '[0-9]*',
  maxlength: 12,
});

const phoneExtendedInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel',
  },
  inputMode: 'numeric',
  pattern: '[0-9]*',
  maxlength: 18,
});

const passwordInputConfig = new InputConfig({
  type: 'password',
});

const zipInputConfig = new InputConfig({
  pattern: '[0-9]*',
  type: {
    default: 'text',
    mobile: 'number',
    android: 'tel',
  },
  maxlength: 5,
});

const zipExtendedInputConfig = new InputConfig({
  pattern: '[0-9]*',
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel',
  },
  maxlength: 10,
});

const numericInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'number',
  },
  pattern: '[0-9]*',
  inputMode: 'numeric',
});

const currencyInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel',
  },
  pattern: '[0-9]*',
  inputMode: 'numeric',
});

const currencyIntegerInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel',
  },
  pattern: '[0-9]*',
  inputMode: 'numeric',
});

const interestRateInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel'
  },
  pattern: '[0-9]*',
  inputMode: 'numeric'
});

const ccInputConfig = new InputConfig({
  type: {
    default: 'text',
    mobile: 'text',
    android: 'tel',
  },
  pattern: '[0-9]*',
  inputMode: 'numeric',
});

const helpers = {
  textInput(data) {
    if (data.input.format === 'date') {
      return formatTextInput(data, dateInputConfig);
    }

    if (data.input.format === 'month-year-date') {
      return formatTextInput(data, monthYearDateConfig);
    }

    if (data.input.format === 'ssn' || data.input.format === 'ein') {
      return formatTextInput(data, ssnInputConfig);
    }

    if (data.input.format === 'cc-number') {
      return formatTextInput(data, ccInputConfig);
    }

    return formatTextInput(data, textInputConfig);
  },
  emailInput(data) {
    return formatTextInput(data, emailInputConfig);
  },
  phoneInput(data) {
    if (data.input.format === 'phone-extended') {
      return formatTextInput(data, phoneExtendedInputConfig);
    }

    return formatTextInput(data, phoneInputConfig);
  },
  passwordInput(data) {
    return formatTextInput(data, passwordInputConfig);
  },
  numericInput(data) {
    if (data.input.format === 'zip') {
      return formatTextInput(data, zipInputConfig);
    }
    if (data.input.format === 'zip-extended') {
      return formatTextInput(data, zipExtendedInputConfig);
    }

    return formatTextInput(data, numericInputConfig);
  },
  interestRateInput(data) {
    return formatTextInput(data, interestRateInputConfig);
  },
  currencyInput(data) {
    if (data.input.format === 'currency-integer') {
      return formatTextInput(data, currencyIntegerInputConfig);
    }

    return formatTextInput(data, currencyInputConfig);
  },
  numberInput(data) {
    return new Handlebars.SafeString('<b><i>The "numberInput" helper is not supported in SPARTA 2.0 - it has been replaced by the "numericInput" helper</i></b>');
  },
  dateInput(data) {
    return new Handlebars.SafeString('<b><i>The "dateInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
  },
  internalAccountNumberInput(data) {
    return new Handlebars.SafeString('<b><i>The "internalAccountNumberInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
  },
  externalAccountNumberInput(data) {
    return new Handlebars.SafeString('<b><i>The "externalAccountNumberInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
  },
  ssnInput(data) {
    return new Handlebars.SafeString('<b><i>The "ssnInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
  },
  zipInput(data) {
    return new Handlebars.SafeString('<b><i>The "zipInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
  },
  percentInput(data) {
    return new Handlebars.SafeString('<b><i>The "percentInput" helper is not supported in SPARTA 2.0 - you should use the "numericInput" helper with the appropriate validation rules applied</i></b>');
  }
};

/**
 * @class inputHelpers
 * @description Class used to register our helper with Handlebars
 */
class inputHelpers {
  /**
   * @method register
   * @param {Object} Handlebars reference to Handlebars for helper registration
   * @description registers helper with Handlebars
   */
  static register(Handlebars) {
    Object.keys(helpers).forEach((key) => {
      Handlebars.registerHelper(key, helpers[key]);
    });
  }
}

module.exports = inputHelpers;
